import Cookies from "universal-cookie";

const cookies = new Cookies()

export default function setCookie(cookieName, token) {
    cookies.set(cookieName, token);

}